import { NO } from "uicore-ts"
import type { RHProcurementInformativeStatus } from "../SocketClientFunctions"


export type OffererProcurementSituationFilterKey = "registeredOnly" | "draftOffer" | "submitted"


type OffererProcurementSituationSource = {
    offererInformativeStatus?: RHProcurementInformativeStatus
}


export class OffererProcurementSituationFilter {

    static doesProcurementMatchFilter(
        procurement: OffererProcurementSituationSource,
        filterKey: OffererProcurementSituationFilterKey
    ): boolean {
        if (filterKey === "registeredOnly") {
            return procurement.offererInformativeStatus?.kind === "registeredAsTenderer"
        }
        if (filterKey === "draftOffer") {
            return procurement.offererInformativeStatus?.kind === "offerInProgress"
        }
        if (filterKey === "submitted") {
            return procurement.offererInformativeStatus?.kind === "offerSubmitted"
        }
        return NO
    }

}
